import {create} from "@acng/frontend-bounty/object.js";
import {add, createSet, has} from "@acng/frontend-bounty/collection.js";
import {isDefined} from "@acng/frontend-bounty/types.js";

const MODULE = "stargazer/registry";
const VERBOSE = false;
DEBUG: if (VERBOSE) console.warn("Import verbose", MODULE);

/**
 * @template {string} T
 * @param {T} name
 * @param {ElementSetup<T>} setup
 */
export function defineRegistryElement(name, setup) {
  DEBUG: if (VERBOSE) console.info(MODULE, "define element", {name, setup});
  ASSERT: if (isDefined(elementCallbacks[name]))
    console.warn(MODULE, "already defined element override", {
      name,
      setup,
      previous: elementCallbacks[name],
    });

  elementCallbacks[name] = setup;
}

/**
 * @template {string} T
 * @param {T} name
 * @param {AttributeSetup<T>} setup
 */
export function defineRegistryAttribute(name, setup) {
  DEBUG: if (VERBOSE) console.info(MODULE, "define attribute", {name, setup});
  ASSERT: if (isDefined(attributeCallbacks[name]))
    console.warn(MODULE, "already defined attribute override", {
      name,
      setup,
      previous: attributeCallbacks[name],
    });

  attributeCallbacks[name] = setup;
}

/**
 * @type {Record<string, ElementSetup<any> | undefined>}
 */
const elementCallbacks = create();

/**
 * @type {Record<string, AttributeSetup<any> | undefined>}
 */
const attributeCallbacks = create();

/**
 * @param {Record<string, ElementSetup<any> | AttributeSetup<any> | undefined>} callbacks
 * @returns {(key: string) => void}
 */
const UniqueCallback = (callbacks) => {
  /**
   * @type {Set<string>}
   */
  const alreadyInvoked = createSet();

  return (name) => {
    if (!has(alreadyInvoked, name)) {
      callbacks[name]?.(name);
      add(alreadyInvoked, name);
    }
  };
};

/**
 * @internal
 * @param {string} name
 */
export const setupElement = UniqueCallback(elementCallbacks);

/**
 * @internal
 * @param {string} name
 */
export const setupAttribute = UniqueCallback(attributeCallbacks);

/**
 * @template {string} T
 * @callback ElementSetup
 * @param {T} name
 * @returns {void}
 */

/**
 * @template {string} T
 * @callback AttributeSetup
 * @param {T} name
 * @returns {void}
 */
